import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

export function NoAnswer() {
  const { t } = useTranslation()
  return (
    <Text c="dimmed" flex="0 0 auto" fz="lg">
      {t("No answer")}
    </Text>
  )
}
